import React from "react";

const InnerFooter = () => {
  return (
    <div className="confident-banner">
      <p>Be a more Confident Vet.</p>
      <div className="confident-blue-line"></div>
    </div>
  )
}

export default InnerFooter;